import React from "react";
import { Box, Typography } from "@mui/material";
import { parsePrescriptionSummarySections } from "../../../helpers/prescriptionSummaryFormat";

export {
  parsePrescriptionSummarySections,
  type PrescriptionSummarySection
} from "../../../helpers/prescriptionSummaryFormat";

export default function PrescriptionSummaryPrint({ text }: { text: string }): React.ReactNode {
  const sections = parsePrescriptionSummarySections(text);

  if (sections.length === 0) return null;

  return (
    <Box
      sx={{
        width: "100%",
        pt: 2,
        mt: 1
      }}
    >
      {sections.map((section, index) => (
        <Box
          key={`${section.title}::${section.body}`}
          sx={{
            mt: index === 0 ? 0 : 3,
            pageBreakInside: "avoid"
          }}
        >
          {section.title ? (
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "14px",
                mb: 1
              }}
            >
              {section.title}
            </Typography>
          ) : null}
          {section.body ? (
            <Typography
              variant="subtitle1"
              component="div"
              sx={{
                whiteSpace: "pre-line",
                lineHeight: 1.65
              }}
            >
              {section.body}
            </Typography>
          ) : null}
        </Box>
      ))}
    </Box>
  );
}
